<h3 mat-dialog-title>{{ 'GeneralMeeting.Import' | translate }}</h3>
<div mat-dialog-content>
    <div>
        <div>{{ 'FileUpload.SelectFile' | translate }}</div>
        <input type="file" (change)="fileSelected($event)" />
    </div>
    @if (hasFinished) {
        <div class="message">
            @if (isSuccessful) {
                <span class="successful">{{ 'GeneralMeeting.ImportedSuccessfully' | translate }}</span>
            }
            @if (!isSuccessful) {
                <span class="failed">{{ 'GeneralMeeting.ImportFailed' | translate }}</span>
            }
        </div>
    }
</div>
<div mat-dialog-actions class="float-right">
    @if (!hasStarted) {
        <button mat-button (click)="cancel()">{{ 'General.Cancel' | translate }}</button>
    }
    @if (!hasStarted) {
        <button mat-button (click)="upload()">{{ 'GeneralMeeting.Import' | translate }}</button>
    }
    @if (hasFinished) {
        <button mat-button mat-dialog-close>{{ 'General.Close' | translate }}</button>
    }
    @if (hasStarted && !hasFinished) {
        <mat-spinner [diameter]="32" />
    }
</div>
